<!-- Invite List-->
<div class="row">
  <invite-card-preview
    [hidden]="loading"
    class="col-md-4"
    *ngFor="let invite of results"
    [invite]="invite"
    [config]="config"
    [currentUser]="currentUser"
    (updateInvites)="updateInvites($event)"
    (updateLoading)="updateLoading($event)"
  >
  </invite-card-preview>
</div>

<!-- Loader spinner -->
<loader-animation [loading]="loading" [message]="'Loading invites'">
</loader-animation>
<!-- Loader spinner -->

<!-- No content message-->
<no-content-msg
  [hidden]="loading || results.length"
  [message]="'No invites here yet'"
>
</no-content-msg>
<!-- No content message -->

<!-- Pagination -->
<pagination-buttons
  [currentPage]="currentPage"
  [loading]="loading"
  [showNavBar]="true"
  [smallButtons]="false"
  [totalPageCount]="totalPages"
  (setPageTo)="setPageTo($event)"
>
</pagination-buttons>
<!-- Pagination -->
